<template>
  <layout>
    <!--状态切换区-->
    <template v-slot:pageTab>
      <div class="libtn">
        <span class="li" :class="{ on: searchMap.status == '100' }" @click="search('100')">购物车({{ $store.state.carCount.isGuanzhuNum || 0 }})</span>
        <div class="li">
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-fuzhi" @click="$copyZhuanliOne()">复制</Button>
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-fuzhi" @click="$copyZhuanliLook(pageThis, true)">带价复制</Button>
        </div>
        <div class="li">
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-Excel" @click="$QHexcelDownload(pageThis, 'isCar', false, $store.state.user.account+'的购物车')">导出</Button>
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-Excel" @click="$QHexcelDownload(pageThis, 'isCar', true, $store.state.user.account+'的购物车')">带价导出</Button>
        </div>
        <div class="li">
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-haibao" @click="$createdHaibaoLook(pageThis, false, '万知达优选专利')">海报</Button>
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-haibao" @click="$createdHaibaoLook(pageThis, true, '万知达优选专利')">带价海报</Button>
        </div>
        <div class="li">
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-shanchu" @click="$batchRemoveFromCart(selectedRows)">批量移除购物车</Button>
          <Button type="default" size="small" class="ML5" custom-icon="iconfont icon-shanchu" @click="$batchMoveToCart(selectedRows)">清空购物车</Button>
        </div>
      </div>
    </template>
    <!--状态切换区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="margin-right: 20px">
          <RadioGroup v-model="searchMap.kind" type="button" size="small" @on-change="searchTab()">
            <Radio label="100">发明</Radio>
            <Radio label="200">实用</Radio>
            <Radio label="300">外观</Radio>
            <Radio label="">不限</Radio>
          </RadioGroup>
        </li>
        <li style="margin-right: 20px">
          <RadioGroup v-model="searchMap.type" type="button" size="small" @on-change="searchTab()">
            <Radio label="200">下证</Radio>
            <Radio label="100">未下</Radio>
            <Radio label="300">未知</Radio>
            <Radio label="">不限</Radio>
          </RadioGroup>
        </li>
        <li>
          <RadioGroup v-model="searchMap.sort" type="button" size="small" @on-change="searchTab()">
            <Radio label="价格" disabled>价格</Radio>
            <Radio label="100">↑</Radio>
            <Radio label="200">↓</Radio>
          </RadioGroup>
        </li>
        <li class="liMe">
          <Input size="small" maxlength="12" style="width: 270px" prefix="ios-search" v-model="searchMap.keyword" placeholder="按专利号、名称、技术关键词" />
          <Input size="small" style="margin-left: 10px; width: 160px" maxlength="12" prefix="ios-search" v-model="searchMap.keywordSummary" placeholder="按摘要关键词" />
          <Button type="info" size="small" class="ML5" @click="search()">搜索</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageSize="25" :pageThis="pageThis" :current="searchMap.pageNo">
        <Table :columns="columns" :data="listThis" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loadingTable" class="QHTableList">
          <!--加入与取消购物车-->
          <template slot-scope="{ row }" slot="cellGuanzhu">
            <span class="TOOLA CL5 QHtagicon iconfont icon-yichu2" v-if="$isArr(row.id, $store.state.carCount.isGuanzhu || [])" @click="$onOffGuanzhu(row, 'yiGuanzhu', $event)"></span>
            <span class="TOOLA CL3 QHtagicon iconfont icon-jiarugouwuche-weijiaru" cart v-else @click="$onOffGuanzhu(row, 'weiGuanzhu', $event)"></span>
          </template>

          <!--订单提醒-->
          <template slot-scope="{ row }" slot="caigouStatus">
            <template>
              <span class="CL11 QHtagicon iconfont icon-tixing" v-if="row.status == 200">被预定</span>
              <span class="CL11 QHtagicon iconfont icon-tixing" v-else-if="row.status == 400">已售出</span>
              <span class="CL11 QHtagicon iconfont icon-tixing" v-else-if="row.status == 500">已下架</span>
              <span class="CL4 TOOLB QHtagicon iconfont icon-gouwuchecart-fill" v-else @click="$refs.OskefuCG.hello('联系客服预定➥' + row.title)">可预定</span>
            </template>
          </template>

          <!--操作区域-->
          <template slot-scope="{ row }" slot="action">
            <Button type="info" size="small" class="btn" custom-icon="iconfont icon-xiangqing" @click="$refs.detailed.hiPop(row.id, row.orderId)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed" @success="getList()"></detailed>
      <Oshaibao ref="Oshaibao" :title="$U.teamUserName + '预选专利'"></Oshaibao>
      <OskefuCG ref="OskefuCG" :title="$U.teamUserName + '的专属客服'"></OskefuCG>
      <Oscopy ref="Oscopy" title="复制专利"></Oscopy>
      <QHexcelDownload ref="QHexcelDownload" note="导出组件"></QHexcelDownload>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
import Oshaibao from "@/components/Oshaibao/Oshaibao";
import OskefuCG from "@/components/OskefuCG/OskefuCG";
import Oscopy from "@/components/Oscopy/Oscopy";
import QHexcelDownload from "@/components/QHexcelDownload/QHexcelDownload";
export default {
  components: {
    detailed,
    Oshaibao,
    OskefuCG,
    Oscopy,
    QHexcelDownload,
  },
  data() {
    return {
      //列表配置项(loadingTable加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      pageThis: this,
      listThis: [],
      loadingTable: false,
      selectedRows: [],
      total: {},
      columns: [],
      columnsInit: [
        {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "专利类型",
          width: 90,
          key: "kind",
          sortable: true,
          align: "center",
          render: (h, parameter) => {
            var res = parameter.row.kind;
            let txt = this.$s("zhuanKind", res);
            return h("span", txt);
          },
        },
        {
          title: "下证",
          width: 70,
          align: "center",
          key: "type",
          sortable: true,
          render: (h, parameter) => {
            var res = parameter.row.type;
            let txt = this.$s("zhuanType", res);
            return h("span", txt);
          },
        },
        {
          title: "专利号",
          align: "center",
          key: "applicationNumber",
          width: 120,
          render: (h, parameter) => {
            var txt = parameter.row.applicationNumber;
            if (!this.$isblank(parameter.row.pdf)) {
              return h("span", { class: ["isPDF iconfont icon-file-pdf"] }, txt);
            } else {
              return h("span", { class: ["noPDF"] }, txt);
            }
          },
        },
        {
          title: "专利名称",
          type: "html",
          key: "title",
          width: 400,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "技术关键词/摘要",
          key: "keywords",
          minWidth: 180,
          type: "html",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "专利价格",
          align: "center",
          width: 140,
          key: "price",
          sortable: true,
          render: (h, parameter) => {
            var res = parameter.row.price;
            let txt = this.$amount(res);
            return h("span", txt);
          },
        },
        {
          title: "官费信息",
          align: "center",
          width: 200,
          key: "expenseNote",
          ellipsis: true,
          tooltip: true,
          resizable: true,
          render: (h, parameter) => {
            var row = parameter.row;
            return h("span", row.expenseNote || "");
          },
        },
        {
          title: "官费时间",
          align: "center",
          width: 130,
          hide: true,
          sortable: true,
          key: "expenseTime",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.expenseTime, "YYYY年MM月DD日");
            if (!time) {
              time = "请在详情刷新获取";
            }
            return h("span", time);
          },
        },
        {
          title: "可否预定",
          fixed: "right",
          width: 80,
          slot: "caigouStatus",
          align: "center",
        },
        {
          title: "购物车",
          fixed: "right",
          width: 60,
          slot: "cellGuanzhu",
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ],

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        keywordField: "",
        keyword: "",
        keywordSummary: "",
        kind: "",
        type: "",
        sort: "",
        deadline_type: "",
        deadline_time: "",
        zuiDijia: "",
        zuiGaojia: "",
        status: "all",
        pageNo: 1,
        pageSize: 50,
      },

      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      isGuanzhu: [],
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    //获取URL参数
    var status = this.$getUrlParams("status");
    if (!this.$isblank(status)) {
      this.searchMap.status = status;
    }
    this.$getMYguanzhuzhuanli();
    this.getList();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      let that = this;

      //显示列切换
      this.columns = this.$colFilter(this.columnsInit);

      //API切换
      var api = this.$api.getCGGuanzhuList;
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var https = {
        type: "isPagelist",
        api: api,
        parameter: this.searchMap,
      };
      that.loadingTable = true;
      that.$loading(true);
      this.$httpsApi(
        https,
        function (res) {
          var list = res.data;
          list = list.map((item) => {
            let keywordValue;
            if (item.keyword) {
              keywordValue = item.keyword;
            } else if (item.summary) {
              keywordValue = item.summary;
            }
            item.keywords = keywordValue;
            item.isGuanzhu = true;
            return item;
          });
          that.listThis = list;
          that.loadingTable = false;
          that.$loading(false);
        },
        function (res) {
          that.$loading(false);
        }
      );
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    searchTab() {
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
<style>
.shouchangBtn {
  font-size: 20px !important;
  cursor: pointer;
}
.shouchangBtn:hover {
  color: #409eff !important;
}
.pointer {
  cursor: pointer;
  line-height: 28px;
}
.TOOLA {
  padding: 20px 10px;
  cursor: pointer;
}
.TOOLA:before {
  font-size: 18px !important;
}
.TOOLA:hover:before {
  opacity: 0.6 !important;
}
.TOOLB:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
